const DOCUMENT_ID_TOKEN = /\{DOCUMENT_ID\}/g

/** Angular `processDocumentContent` — swap `{DOCUMENT_ID}` for the real id. */
export function processServiceAgreementHtml(
  rawContent: string | undefined | null,
  documentId: number | string | undefined | null,
): string {
  if (!rawContent) return ''
  const replacement = documentId == null ? '' : String(documentId)
  return rawContent.replace(DOCUMENT_ID_TOKEN, replacement)
}

/**
 * Angular route `/explanation-service-aggrement/:id` (and legacy `/eorp/:id`)
 * opens the Explanation of Reimbursement Process popup for that document.
 */
export function isEorpDocumentLink(href: string | null | undefined): boolean {
  if (!href) return false
  const value = href.toLowerCase()
  return (
    value.includes('explanation-service-aggrement') ||
    /(?:^|\/)eorp\/\d+/i.test(value) ||
    value.includes('/api/eorp/')
  )
}

/** Pull the document id from an EORP href when present. */
export function extractEorpDocumentId(href: string | null | undefined): number | null {
  if (!href) return null
  const match = href.match(
    /(?:explanation-service-aggrement|\/eorp\/|\/api\/eorp\/)\/?(\d+)/i,
  )
  if (!match) return null
  const id = Number(match[1])
  return Number.isFinite(id) && id > 0 ? id : null
}
